import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "react-i18next";
import { Text } from "~/components/text";
import { useSalesData } from "~/contexts/sales-data-context";

export const SalesLastSyncedNote = () => {
  const { t } = useTranslation(["productDetails"]);
  const { lastSyncedAt } = useSalesData();

  if (!lastSyncedAt) {
    return null;
  }

  return (
    <Text as="span" variant="metricCaption" data-testid="sales-last-synced">
      {t("salesData.lastSynced", {
        when: formatDistanceToNow(lastSyncedAt, { addSuffix: true }),
      })}
    </Text>
  );
};
